let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hitr6")).then(() => parcelRequire('bcar5'));